<template>
  <div
    id="app"
    class="bg-offwhite montserrat">
    <the-navbar/>
    <the-header/>
    <section-productivity/>
    <section-features/>
    <section-quality/>
    <section-contact/>
    <section-footer/>
  </div>
</template>

<script>
import emergence from 'emergence.js'

import SectionContact from '@/components/SectionContact'
import SectionFeatures from '@/components/SectionFeatures'
import SectionFooter from '@/components/SectionFooter'
import SectionProductivity from '@/components/SectionProductivity'
import SectionQuality from '@/components/SectionQuality'
import TheHeader from '@/components/TheHeader'
import TheNavbar from '@/components/TheNavbar'
export default {
  name: 'App',

  components: {
    SectionContact,
    SectionFeatures,
    SectionFooter,
    SectionProductivity,
    SectionQuality,
    TheHeader,
    TheNavbar
  },

  mounted () {
    emergence.init()
  }
}
</script>
